<div id="regZusammenfassung">
  <div id="registrierungZusammenfassungCheck" tabindex="0"  >
    <mat-icon>info</mat-icon>
    <span>Bitte prüfen Sie Ihre Angaben!</span>
  </div>
  <div id="registrierungZusammenfassung" [class.web]="detectedPlattform == 'WEB'" *ngIf="mandant && formData">
    <mat-accordion id="vertragstext">
      <mat-expansion-panel expanded *ngIf="mandant.registrierFormen[this.vertragsId].registrierArt !== 2"
                           id="vertrag_text" [class.expansionPanelWeb]="detectedPlattform == 'WEB'" tabindex="0">
        <mat-expansion-panel-header>
          <mat-panel-title><strong>{{ mandant.registrierFormen[vertragsId].name }}</strong></mat-panel-title>
        </mat-expansion-panel-header>
        <app-registrierung-vertrag [vertragsId]="vertragsId" [mandant]="mandant"
                                   [formGroup]="formData"></app-registrierung-vertrag>
      </mat-expansion-panel>
      <mat-card class="registrierungZusammenfassungKarte" id="vertragspartner" tabindex="0">
        <div class="kartenKopf">
          <strong *ngIf="enviroment.envName == '110129-gloria'">Ihre Kundendaten</strong>
          <ng-container *ngIf="enviroment.envName != '110129-gloria'"><strong>Vertragspartner</strong> <span>(ggf. gesetzlicher Vertreter)</span>
          </ng-container>
        </div>
        <div [ngClass]="detectedPlattform != 'WEB' ? 'personenAngabenApp' : 'personenAngabenAbschluss'"
             appRegistrierungZusammenfassungRenderer
             [formData]="formData"
             [formConfig]="formConfig['vertragspartner']"
        >
        </div>
      </mat-card>

      <mat-card class="registrierungZusammenfassungKarte"
                appRegistrierungZusammenfassungParser
                [formData]="formData"
                [formConfig]="formConfig['essensteilnehmer']"
                id="essensteilnehmer"
                tabindex="0"
      >
        <strong>Essensteilnehmer</strong>
        <div id="essensteilnehmer1"
             [ngClass]="detectedPlattform != 'WEB' ? 'personenAngabenApp' : 'personenAngabenAbschluss'"
             appRegistrierungZusammenfassungRenderer
             [formData]="formData"
             [formConfig]="formConfig['essensteilnehmer']"
        >
        </div>
      </mat-card>

      <mat-card class="registrierungZusammenfassungKarte"
                appRegistrierungZusammenfassungParser
                [formData]="formData"
                [formConfig]="formConfig['rechnungskunde']"
                id="rechnungskunde"
                tabindex="0"
      >
        <strong>Rechnungskunde</strong>
        <div id="rechnungskunde1"
             [ngClass]="detectedPlattform != 'WEB' ? 'personenAngabenApp' : 'personenAngabenAbschluss'"
             appRegistrierungZusammenfassungRenderer
             [formData]="formData"
             [formConfig]="formConfig['rechnungskunde']"
        >
        </div>
      </mat-card>

      <mat-card class="registrierungZusammenfassungKarte"
                appRegistrierungZusammenfassungParser
                [formData]="formData"
                [formConfig]="formConfig['bankverbindung']"
                id="bankverbindung"
                tabindex="0"
      >
        <strong>Bankverbindung</strong>
        <span *ngIf="enviroment.envName != '110129-gloria' && enviroment.mandant_id != '102710-gastromenue5'" class="formularHinweis bankVerbindungHinweis">
            Mit dem Eintragen Ihrer Bankdaten ermächtigen Sie uns zur SEPA-Lastschift und erteilen uns ein SEPA-Lastschriftmandat.
          </span>
        <span *ngIf="enviroment.envName == '110129-gloria'" class="formularHinweis bankVerbindungHinweis">
            Mit dem Eintragen Ihrer Bankdaten ermächtigen Sie uns zur SEPA-Lastschrift und erteilen uns ein SEPA-Lastschriftmandat. Sollten Sie keine Bankdaten angeben und per Überweisung zahlen wollen, so müssen wir für den deutlich höheren Verwaltungsaufwand eine Gebühr in Höhe von 2,00 € je Rechnungswoche erheben.
          </span>
        <div id="bankverbindungMobil" [class.bankverbindungWeb]="detectedPlattform == 'WEB'"
             appRegistrierungZusammenfassungRenderer
             [formData]="formData"
             [formConfig]="formConfig['bankverbindung']"
        >
        </div>
      </mat-card>

      <mat-card class="registrierungZusammenfassungKarte"
                appRegistrierungZusammenfassungParser
                [formData]="formData"
                [formConfig]="formConfig['zahlung']"
                id="zahlung"
                tabindex="0"
      >
        <strong>Zahlung</strong>
        <div id="zahlungMobil" [class.zahlungWeb]="detectedPlattform == 'WEB'"
             appRegistrierungZusammenfassungRenderer
             [formData]="formData"
             [formConfig]="formConfig['zahlung']"
        >
        </div>
      </mat-card>

      <mat-card
                class="registrierungZusammenfassungKarte"
                appRegistrierungZusammenfassungParser
                [formData]="formData"
                [formConfig]="formConfig['einrichtung']"
                id="einrichtung"
                tabindex="0"
      >
        <strong>Einrichtung</strong>
        <div id="einrichtungMobil"
             [class.einrichtungWeb]="detectedPlattform == 'WEB'"
             appRegistrierungZusammenfassungRenderer
             [formData]="formData"
             [formConfig]="formConfig['einrichtung']"
        >
        </div>
      </mat-card>

      <mat-card class="registrierungZusammenfassungKarte"
                appRegistrierungZusammenfassungParser
                [formData]="formData"
                [formConfig]="formConfig['anmeldung']"
                id="anmeldung"
                tabindex="0"
      >
        <strong>Anmeldung</strong>
        <div id="anmeldungMobil" [class.anmeldungWeb]="detectedPlattform == 'WEB'"
             appRegistrierungZusammenfassungRenderer
             [formData]="formData"
             [formConfig]="formConfig['anmeldung']"
        >
        </div>
      </mat-card>

      <mat-card class="registrierungZusammenfassungKarte" tabindex="0">
        <strong>Zusätzliche Informationen</strong>
        <div id="zusatz" class="zusatz" [class.zusatzAbschluss]="detectedPlattform == 'WEB'"
             appRegistrierungZusammenfassungRenderer
             [formData]="formData"
             [formConfig]="formConfig['zusatz']"
             [class.mobil]="enviroment.type !== 'web'"
        >
          <zusatzfelderZusammenfassung id="checkboxBestellerinnerung"></zusatzfelderZusammenfassung>
        </div>
      </mat-card>
    </mat-accordion>
    <mat-card id="registrierungZusammenfassungOptionen" *ngIf="detectedPlattform != 'WEB'">
      <rechtstexte *ngIf="mandant.betreiberDaten.agb !== ''" [Titel]="'AGB'"
                   [Inhalt]="mandant.betreiberDaten.agb" [Icon]="'fact_check'"></rechtstexte>
      <rechtstexte *ngIf="mandant.betreiberDaten.datenschutz !== ''" [Titel]="'Datenschutz'"
                   [Inhalt]="mandant.betreiberDaten.datenschutz" [Icon]="'security'"></rechtstexte>
      <rechtstexte *ngIf="mandant.betreiberDaten.widerruf !== ''" [Titel]="'Wiederruf'"
                   [Inhalt]="mandant.betreiberDaten.widerruf" [Icon]="'pan_tool'"></rechtstexte>
      <button class="good" mat-flat-button (click)="kundeCommitApi()">
        <mat-icon>check</mat-icon>
        <span>Vertrag anbahnen</span>
      </button>
      <button class="warn" mat-flat-button (click)="verlinkungZumFormular()">
        <mat-icon>edit</mat-icon>
        <span>Registrierung bearbeiten</span>
      </button>
      <button class="bad" mat-flat-button (click)="verlinkungZumLogin()">
        <mat-icon>delete</mat-icon>
        <span>Registrierung abbrechen</span>
      </button>
    </mat-card>
  </div>
</div>
